import { render, staticRenderFns } from "./CompanyRepxStagesMappingSetup.vue?vue&type=template&id=2d532e51&scoped=true"
import script from "./CompanyRepxStagesMappingSetup.vue?vue&type=script&lang=js"
export * from "./CompanyRepxStagesMappingSetup.vue?vue&type=script&lang=js"
import style0 from "./CompanyRepxStagesMappingSetup.vue?vue&type=style&index=0&id=2d532e51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d532e51",
  null
  
)

export default component.exports